import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { RoleIdEnum } from 'app/config/constants';
import { User } from 'app/core/user/user.model';
import { RouteSetting } from 'app/model/entity/route-setting';
import { UserRoute } from 'app/model/entity/user-route';

@Component({
  selector: 'user-manager-select-route',
  templateUrl: './user-manager-select-route.component.html',
  styleUrls: ['./user-manager-select-route.component.scss']
})
export class UserManagerSelectRouteComponent implements OnInit, AfterViewInit {
  @Output() checkboxChanged = new EventEmitter();
  @Input() listUserDisplay: User[] = [];
  @Input() userRoutes: UserRoute[] = [];
  @Input() routeSettings: RouteSetting[] = [];

  @ViewChild('scrollableContent', { static: false }) scrollableContent!: ElementRef;
  form!: FormGroup;

  listUserSetting: User[];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['listUserDisplay'] || changes['userRoutes'] || changes['routeSettings']) {
      this.initializeForm();
    }
  }

  ngAfterViewInit() {
    this.addHorizontalScrollListener();
  }

  private addHorizontalScrollListener() {
    if (this.scrollableContent) {
      const element = this.scrollableContent.nativeElement;

      element.addEventListener(
        'wheel',
        (event: WheelEvent) => {
          event.preventDefault();

          const scrollSpeed = 70;
          const deltaY = event.deltaY;

          element.scrollLeft += deltaY > 0 ? scrollSpeed : -scrollSpeed;
        },
        { passive: false }
      );
    }
  }

  onTableWheel(event: WheelEvent) {
    event.preventDefault();
    const scrollSpeed = 70;
    const element = event.currentTarget as HTMLElement;
    element.scrollLeft += event.deltaY > 0 ? scrollSpeed : -scrollSpeed;
  }

  private initializeForm(): void {
    this.listUserSetting = this.listUserDisplay.filter(user => user.roleId === RoleIdEnum.USER);
    if (this.userRoutes && this.routeSettings) {
      this.form = this.fb.group({
        users: this.fb.array(this.userRoutes.map(user => this.createUserFormGroup(user)))
      });
    }
  }

  private createUserFormGroup(user: UserRoute): FormGroup {
    const userControls: { [key: string]: any } = {
      name: [`${user.stopCode}_${user.routeName}`]
    };

    this.listUserSetting.forEach((displayUser, index) => {
      const existingSetting: RouteSetting = (this.routeSettings || []).find(
        rSetting => rSetting.userEmail === displayUser.email && rSetting.routeId === user.id
      );
      userControls[`checkbox_${index}`] = existingSetting ? [existingSetting.isActive] : [false];
    });

    return this.fb.group(userControls);
  }

  get usersFormArray(): FormArray {
    return this.form.get('users') as FormArray;
  }

  changeEvent(e: Event, i: any, j: any) {
    const checked = (e.target as HTMLInputElement).checked;

    const routeChange = this.userRoutes[i];
    const userChange = this.listUserSetting[j];
    this.checkboxChanged.emit({
      routeChange,
      userChange,
      checked
    });
  }

  resetToInitialState(): void {
    this.form.markAsPristine();
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
}
